import React from 'react';

import { trackCustomEvent, marketoCustomEvent } from '@helpers/utils';

import Link from '@common/Link';

import DownloadImg from '@images/download.svg';

const DownloadButton = ({
  url,
  copy }) => {
  return (
    <Link
      className='fw-semibold me-2 d-flex fs-12 align-items-center flex-row text-blue-dark'
      target='_blank'
      rel='noopener noreferrer'
      onClick={e => {
        marketoCustomEvent({
          url: e.target.baseURI
        });
        trackCustomEvent({
          category: 'pdf-download',
          action: 'click'
        })
      }}
      to={url}
    >
      <img width={19} height={13} className='me-1' src={DownloadImg} alt='' />
      {copy}
    </Link>
  )
}

export default DownloadButton